/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M18 1V4M18 4V7M18 4H15M18 4H21M8 8H14M8 12H12M8 16H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.5 4H11H10.4C8.15979 4 7.03968 4 6.18404 4.43597C5.43139 4.81947 4.81947 5.43139 4.43597 6.18404C4 7.03968 4 8.15979 4 10.4V15.6C4 17.8402 4 18.9603 4.43597 19.816C4.81947 20.5686 5.43139 21.1805 6.18404 21.564C7.03968 22 8.15979 22 10.4 22H11.6C13.8402 22 14.9603 22 15.816 21.564C16.5686 21.1805 17.1805 20.5686 17.564 19.816C18 18.9603 18 17.8402 18 15.6V10.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M4 10.4C4 8.15979 4 7.03969 4.43597 6.18404C4.81947 5.43139 5.43139 4.81947 6.18404 4.43597C7.03969 4 8.15979 4 10.4 4H18V15.6C18 17.8402 18 18.9603 17.564 19.816C17.1805 20.5686 16.5686 21.1805 15.816 21.564C14.9603 22 13.8402 22 11.6 22H10.4C8.15979 22 7.03969 22 6.18404 21.564C5.43139 21.1805 4.81947 20.5686 4.43597 19.816C4 18.9603 4 17.8402 4 15.6V10.4Z"
				fill="currentColor"
			/>
			<path
				d="M18 10.5V15.6C18 17.8402 18 18.9603 17.564 19.816C17.1805 20.5686 16.5686 21.1805 15.816 21.564C14.9603 22 13.8402 22 11.6 22H10.4C8.15979 22 7.03968 22 6.18404 21.564C5.43139 21.1805 4.81947 20.5686 4.43597 19.816C4 18.9603 4 17.8402 4 15.6V10.4C4 8.15979 4 7.03968 4.43597 6.18404C4.81947 5.43139 5.43139 4.81947 6.18404 4.43597C7.03968 4 8.15979 4 10.4 4H11.5M18 1V4M18 4V7M18 4H15M18 4H21M8 8H14M8 12H12M8 16H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.8 1H16.2C15.0799 1 14.5198 1 14.092 1.21799C13.7157 1.40973 13.4097 1.71569 13.218 2.09202C13 2.51984 13 3.07989 13 4.2V5.8C13 6.9201 13 7.48016 13.218 7.90798C13.4097 8.2843 13.7157 8.59027 14.092 8.78201C14.5198 9 15.0799 9 16.2 9H17.8C18.9201 9 19.4802 9 19.908 8.78201C20.2843 8.59027 20.5903 8.2843 20.782 7.90798C21 7.48016 21 6.9201 21 5.8V4.2C21 3.07989 21 2.51984 20.782 2.09202C20.5903 1.71569 20.2843 1.40973 19.908 1.21799C19.4802 1 18.9201 1 17.8 1ZM3.25 9.65V16.35C3.25 18.5902 3.25 19.7103 3.68597 20.566C4.06947 21.3186 4.68139 21.9305 5.43404 22.314C6.28968 22.75 7.40979 22.75 9.65 22.75H12.35C14.5902 22.75 15.7103 22.75 16.566 22.314C17.3186 21.9305 17.9305 21.3186 18.314 20.566C18.75 19.7103 18.75 18.5902 18.75 16.35V12.1C18.75 11.5399 18.75 11.2599 18.641 11.046C18.5451 10.8578 18.3922 10.7049 18.204 10.609C17.9901 10.5 17.7101 10.5 17.15 10.5H16.3C14.6198 10.5 13.7798 10.5 13.138 10.173C12.5735 9.8854 12.1146 9.42646 11.827 8.86197C11.5 8.22024 11.5 7.38016 11.5 5.7V4.85C11.5 4.28995 11.5 4.00992 11.391 3.79601C11.2951 3.60785 11.1422 3.45487 10.954 3.35899C10.7401 3.25 10.4601 3.25 9.9 3.25H9.65C7.40979 3.25 6.28968 3.25 5.43404 3.68597C4.68139 4.06947 4.06947 4.68139 3.68597 5.43404C3.25 6.28968 3.25 7.40979 3.25 9.65ZM6.25 10C6.25 9.58579 6.58579 9.25 7 9.25H9C9.41421 9.25 9.75 9.58579 9.75 10C9.75 10.4142 9.41421 10.75 9 10.75H7C6.58579 10.75 6.25 10.4142 6.25 10ZM6.25 14C6.25 13.5858 6.58579 13.25 7 13.25H13C13.4142 13.25 13.75 13.5858 13.75 14C13.75 14.4142 13.4142 14.75 13 14.75H7C6.58579 14.75 6.25 14.4142 6.25 14ZM6.25 18C6.25 17.5858 6.58579 17.25 7 17.25H10C10.4142 17.25 10.75 17.5858 10.75 18C10.75 18.4142 10.4142 18.75 10 18.75H7C6.58579 18.75 6.25 18.4142 6.25 18ZM17.75 3C17.75 2.58579 17.4142 2.25 17 2.25C16.5858 2.25 16.25 2.58579 16.25 3V4.25H15C14.5858 4.25 14.25 4.58579 14.25 5C14.25 5.41421 14.5858 5.75 15 5.75H16.25V7C16.25 7.41421 16.5858 7.75 17 7.75C17.4142 7.75 17.75 7.41421 17.75 7V5.75H19C19.4142 5.75 19.75 5.41421 19.75 5C19.75 4.58579 19.4142 4.25 19 4.25H17.75V3Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M18 10.5V15.6C18 17.8402 18 18.9603 17.564 19.816C17.1805 20.5686 16.5686 21.1805 15.816 21.564C14.9603 22 13.8402 22 11.6 22H10.4C8.15979 22 7.03968 22 6.18404 21.564C5.43139 21.1805 4.81947 20.5686 4.43597 19.816C4 18.9603 4 17.8402 4 15.6V15M11.5 4H10.4C8.15979 4 7.03968 4 6.18404 4.43597C5.43139 4.81947 4.81947 5.43139 4.43597 6.18404C4 7.03968 4 8.15979 4 10.4V11M18 1V4M18 4V7M18 4H15M18 4H21M8 8H14M8 12H12M8 16H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M18 10.5V15.6C18 17.8402 18 18.9603 17.564 19.816C17.1805 20.5686 16.5686 21.1805 15.816 21.564C14.9603 22 13.8402 22 11.6 22H10.4C8.15979 22 7.03968 22 6.18404 21.564C5.43139 21.1805 4.81947 20.5686 4.43597 19.816C4 18.9603 4 17.8402 4 15.6V10.4C4 8.15979 4 7.03968 4.43597 6.18404C4.81947 5.43139 5.43139 4.81947 6.18404 4.43597C7.03968 4 8.15979 4 10.4 4H11.5M18 1V4M18 4V7M18 4H15M18 4H21M8 8H14M8 12H12M8 16H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M3.25 9.65V16.35C3.25 18.5902 3.25 19.7103 3.68597 20.566C4.06947 21.3186 4.68139 21.9305 5.43404 22.314C6.28969 22.75 7.40979 22.75 9.65 22.75H12.35C14.5902 22.75 15.7103 22.75 16.566 22.314C17.3186 21.9305 17.9305 21.3186 18.314 20.566C18.75 19.7103 18.75 18.5902 18.75 16.35V8H14V3.25H9.65C7.40979 3.25 6.28969 3.25 5.43404 3.68597C4.68139 4.06947 4.06947 4.68139 3.68597 5.43404C3.25 6.28969 3.25 7.40979 3.25 9.65Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.218 2.09202C13 2.51984 13 3.0799 13 4.2V5.8C13 6.9201 13 7.48016 13.218 7.90798C13.4097 8.28431 13.7157 8.59027 14.092 8.78201C14.5198 9 15.0799 9 16.2 9H17.8C18.9201 9 19.4802 9 19.908 8.78201C20.2843 8.59027 20.5903 8.28431 20.782 7.90798C21 7.48016 21 6.9201 21 5.8V4.2C21 3.0799 21 2.51984 20.782 2.09202C20.5903 1.71569 20.2843 1.40973 19.908 1.21799C19.4802 1 18.9201 1 17.8 1H16.2C15.0799 1 14.5198 1 14.092 1.21799C13.7157 1.40973 13.4097 1.71569 13.218 2.09202ZM17.75 3V4.25H19C19.4142 4.25 19.75 4.58579 19.75 5C19.75 5.41421 19.4142 5.75 19 5.75H17.75V7C17.75 7.41421 17.4142 7.75 17 7.75C16.5858 7.75 16.25 7.41421 16.25 7V5.75H15C14.5858 5.75 14.25 5.41421 14.25 5C14.25 4.58579 14.5858 4.25 15 4.25H16.25V3C16.25 2.58579 16.5858 2.25 17 2.25C17.4142 2.25 17.75 2.58579 17.75 3ZM7 9.25C6.58579 9.25 6.25 9.58579 6.25 10C6.25 10.4142 6.58579 10.75 7 10.75H9C9.41421 10.75 9.75 10.4142 9.75 10C9.75 9.58579 9.41421 9.25 9 9.25H7ZM7 13.25C6.58579 13.25 6.25 13.5858 6.25 14C6.25 14.4142 6.58579 14.75 7 14.75H13C13.4142 14.75 13.75 14.4142 13.75 14C13.75 13.5858 13.4142 13.25 13 13.25H7ZM7 17.25C6.58579 17.25 6.25 17.5858 6.25 18C6.25 18.4142 6.58579 18.75 7 18.75H10C10.4142 18.75 10.75 18.4142 10.75 18C10.75 17.5858 10.4142 17.25 10 17.25H7Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
